import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getHprmsFallbackPath,
  isHprmsPathEnabled,
} from "../utilities/moduleConfigurationUtils";

/**
 * Blocks HPRMS routes whose module is turned off in company module config.
 */
const HprmsModuleGate = ({ children }) => {
  const location = useLocation();
  const modules = useSelector((state) => state.moduleConfigState?.modules);
  const pages = useSelector((state) => state.moduleConfigState?.pages);

  if (!isHprmsPathEnabled(location.pathname, modules, pages)) {
    return <Redirect to={getHprmsFallbackPath(modules)} />;
  }

  return children;
};

export default HprmsModuleGate;
